export class SetConnectToken {
  static readonly type = '[AuthState] SetConnectToken';
  constructor(public readonly connectToken: string) {}
}

export class ClearAuth {
  static readonly type = '[AuthState] ClearAuth';
}
